import React from "react";
import { Box, Card, CardBody, CardHeader, Heading, Text } from "@chakra-ui/react";
import SimpleBarChart from "./SimpleBarChart";

const ReportChartCard = ({ title, total, description, series, colorScheme = "blue" }) => {
  return (
    <Card variant="outline" _hover={{ boxShadow: "md" }} transition="box-shadow 0.2s ease">
      <CardHeader>
        <Heading size="sm">{title}</Heading>
      </CardHeader>
      <CardBody>
        <Text fontSize="2xl" fontWeight="semibold">
          {total}
        </Text>
        <Text fontSize="sm" color="gray.600">
          {description}
        </Text>
        <Box mt={4}>
          <SimpleBarChart values={series} colorScheme={colorScheme} />
        </Box>
      </CardBody>
    </Card>
  );
};

export default ReportChartCard;
